import { eMailingCategory } from "./enum.model";
import { SimpleResponse } from "./genericResponse.model";

export interface MailListItem {
    mailingID: number
    subject: string
    category: number
    clpUserID: number
    dtCreated: Date
    mailingStartTime: Date
    status: number
    uFirstName: string
    uLastName: string
    numContacts: number
    numOpened: number
    numSent: number
    mailingType: string
    body: string
    bWCampaign: string
    bWBrand: string
}

export interface MailListItemResponse extends SimpleResponse {
    mailListItems: MailListItem[];
}

export interface MailingSearchByCategoryObj {
    clpCompanyId: number;
    clpUserId: number;
    mailCategory: eMailingCategory;
    filterBy: string;
    fromDt: string;
    toDt: string;
    selectedUserId: string;
    loadEmail: boolean;
    mailingType: number;
}
